import React from 'react';
import ReactGA from 'react-ga';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Button} from '@gisatcz/ptr-atoms';

import eo4drr from "../../assets/img/logo-eo4drr-white.png";
import esa from "../../assets/img/logo-esa.png";
import './style.scss';

class IntroOverlay extends React.PureComponent {
	static defaultProps = {
		open: true
	}

	static propTypes = {
		open: PropTypes.bool
	}

	constructor(props) {
		super(props);
	}

	changeState(changeSource) {
		let action = 'Close intro via x';
		if (changeSource === "title") {
			action = this.props.open ? "Close intro via title" : "Open intro"
		}

		ReactGA.event({
			category: 'Basic interaction',
			action,
			label: 'intro'
		});

		this.props.changeState(!this.props.open);
	}

	render() {
		const classes = classnames("eo4sdDrrInsarMyanmar20-intro-overlay", {
			minimised: !this.props.open
		});

		return (
			<div className={classes}>
				<Button className="eo4sdDrrInsarMyanmar20-overlay-close" icon="times" invisible inverted onClick={this.changeState.bind(this, 'button')}/>
				<div id="eo4sdDrrInsarMyanmar20-header" onClick={this.changeState.bind(this, 'title')}><span>EO4SD-DRR Service Demo 06-WB-MYA</span>Assessment of landslide hazard to Chin road corridor</div>
				<div className="eo4sdDrrInsarMyanmar20-intro-content">
					<div>
						<p>
							The Landslide hazard in road corridor in Chin State project (P 158194) is a part of an ongoing Myanmar Flood and Landslide ERC Project (US$200 million), which supports the resilient rehabilitation of national and rural roads in select Regions and States, including Southern Rakhine and Chin States It is implemented by the Ministry of Construction (MOC) with financing from the World Bank. In Chin State, the project is supporting the rehabilitation of 90 miles (145 km) of the road corridor between Kale and Hakha (the total length of the road corridor is 192km) which passes through hilly areas extremely prone to landslides.
						</p>
						<p>The EO4SD-DRR service delivers an ensemble of products aimed at evidence-based support to design of rehabilitation works in road corridor between Kale and Hakha in Chin state, Myanmar. The geospatial information helps in determining slope zones and road segments prone to landslide occurrence and aim to address need of prioritization of the design of mitigation measures. Patterns of landslide susceptibility have been assessed by modelling and by analysis of slope instabilities derived by satellite interferometry (InSAR).</p>
						<p>Slow-motion terrain deformations on slopes passed by the Chin road were detected by PSI and SBAS interferometric methods. Displacement velocity map shows slope or asset’s instabilities of either natural or anthropogenic origin. Results have been derived from 3 orbital trajectories of Sentinel-1 constellation: both Ascending and Descending tracks. This set-up brings advantage in roughed hilly terrain in Chin state as slopes affected by topographic artefacts in results from one orbital direction could have been complemented by results from another one and vice versa.</p>
						<p>The exposure visualization panel shows exposure of slopes and road segments to hazard represented by slow slope deformations. Thus, the product allows to identify the riskiest segments by assessing the exposure intensity.</p>
					</div>
				</div>
				<div className="eo4sdDrrInsarMyanmar20-intro-footer">
					<div className="eo4sdDrrInsarMyanmar20-intro-logos">
						<a href="https://www.eo4sd-drr.eu/" target="_blank" rel="noreferrer noopener"><img className="eo4drr" src={eo4drr}/></a>
						<a href="http://www.esa.int/" target="_blank" rel="noreferrer noopener"><img className="esa" src={esa}/></a>
					</div>
					<div className="eo4sdDrrInsarMyanmar20-intro-copyrights">
						© {`${new Date().getFullYear()}`} <a href="http://gisat.cz/content/en" target="_blank" rel="noreferrer noopener">Gisat</a>
					</div>
				</div>
			</div>
		);
	}
}

export default IntroOverlay;
